import { inject, Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AbstractForm } from '@core/abstract/form';
import { PaymentType } from '@shared/data/payment-type';
import { SelectTicketState } from '@shared/state/select-ticket.state';
import { distinctUntilChanged } from 'rxjs';

export enum PrintedTicketFormField {
    // eslint-disable-next-line no-shadow
    PaymentType = 'paymentType',
    Price = 'price',
    Sid = 'sid',
    TermCode = 'termCode',
    TrfId = 'trfId',
    SrvId = 'srvId',
    TrmId = 'trmId',
    PaymentAccepted = 'paymentAccepted',
}

export type PrintedTicketFormModel = {
    [PrintedTicketFormField.PaymentType]: FormControl<PaymentType>;
    [PrintedTicketFormField.Price]: FormControl<number>;
    [PrintedTicketFormField.Sid]: FormControl<string>;
    [PrintedTicketFormField.TermCode]: FormControl<string>;
    [PrintedTicketFormField.TrfId]: FormControl<number>;
    [PrintedTicketFormField.TrmId]: FormControl<number>;
    [PrintedTicketFormField.SrvId]: FormControl<number>;
    [PrintedTicketFormField.PaymentAccepted]: FormControl<boolean>;
};

@Injectable()
export class PrintedTicketFormService extends AbstractForm<PrintedTicketFormField, PrintedTicketFormModel> {
    readonly #selectTicketState: SelectTicketState = inject(SelectTicketState);

    public createReactiveForm(): FormGroup<PrintedTicketFormModel> {
        this.build({
            [PrintedTicketFormField.PaymentType]: new FormControl<PaymentType>(PaymentType.Cash, [Validators.required]),
            [PrintedTicketFormField.Price]: new FormControl<number>(null, []),
            [PrintedTicketFormField.Sid]: new FormControl<string>(null, []),
            [PrintedTicketFormField.TermCode]: new FormControl<string>(null, [Validators.required]),
            [PrintedTicketFormField.TrfId]: new FormControl<number>(
                {
                    value: null,
                    disabled: true,
                },
                [Validators.required],
            ),
            [PrintedTicketFormField.TrmId]: new FormControl<number>(null, [Validators.required]),
            [PrintedTicketFormField.SrvId]: new FormControl<number>(
                {
                    value: null,
                    disabled: true,
                },
                [Validators.required],
            ),
            [PrintedTicketFormField.PaymentAccepted]: new FormControl<boolean>(null, [Validators.required]),
        });

        this.defineMechanics();

        return this.form;
    }

    private defineMechanics(): void {
        this.watchForValueChanges(PrintedTicketFormField.TrmId)
            .pipe(distinctUntilChanged())
            .subscribe((trmId: number) => {
                this.#selectTicketState.setTransportManagerId(trmId);
                this.getControlByPath(PrintedTicketFormField.TrfId).setValue(null, { emitEvent: false });
                this.getControlByPath(PrintedTicketFormField.SrvId).setValue(null, { emitEvent: false });
                this.getControlByPath(PrintedTicketFormField.TrfId).setValue(null, { emitEvent: false });

                this.getControlByPath(PrintedTicketFormField.SrvId).enable({ emitEvent: false });
            });

        this.watchForValueChanges(PrintedTicketFormField.SrvId)
            .pipe(distinctUntilChanged())
            .subscribe((srvId: number) => {
                this.#selectTicketState.setServiceId(srvId);

                this.getControlByPath(PrintedTicketFormField.TrfId).setValue(null, { emitEvent: false });
                this.getControlByPath(PrintedTicketFormField.TrfId).enable({ emitEvent: false });
            });
    }
}
